import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  gridTable: {
    width: '100%',
  },
  gridHeader: {
    display: 'grid',
    gridTemplateColumns: '60% 40%',
    columnGap: theme.spacing(2),
    alignItems: 'end',
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  gridRow: {
    display: 'grid',
    gridTemplateColumns: '60% 40%',
    columnGap: theme.spacing(2),
    alignItems: 'start',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: theme.spacing(0.5),
    },
  },
  colInstance: {
    minWidth: 0,
  },
  colAsset: {
    minWidth: 0,
  },
  instanceLink: {
    fontWeight: 500,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    display: 'block',
  },
  assetName: {
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    display: 'block',
  },
  headerCaption: {
    fontWeight: 600,
    letterSpacing: '0.02em',
  },
  headerCaptionAsset: {
    fontWeight: 600,
    letterSpacing: '0.02em',
  },
  loadMoreWrap: {
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
